/* Feel-Ink · utilidades de rendimiento y UX del builder
   1) Optimizador de imagenes: pide al CDN de Shopify el ancho que realmente se muestra.
   2) Controlador del bundle builder (solo en /apps/gbb/easybundle/9).
*/

/* ---------- 1. OPTIMIZADOR DE IMAGENES (todas las paginas) ----------
   Shopify solo aplica su pipeline de compresion cuando la URL lleva ?width=.
   Sin ese parametro sirve el archivo grande. Aqui lo anadimos ANTES de que
   la imagen se descargue, y solo en imagenes lazy que todavia no empezaron a cargar,
   para no provocar una segunda peticion. */
(() => {
  const PASOS = [120, 200, 300, 400, 550, 700, 900, 1100, 1400, 1800];
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const elegir = (px) => PASOS.find((p) => p >= px) || PASOS[PASOS.length - 1];

  const optimizar = (img) => {
    if (img.dataset.feelImg) return;
    const src = img.getAttribute('src');
    if (!src || src.startsWith('data:')) return;

    let u;
    try { u = new URL(src, location.href); } catch (e) { return; }
    if (!/\/(cdn\/shop|s\/files)\//.test(u.pathname)) return;   // solo CDN de Shopify
    if (u.searchParams.has('width')) { img.dataset.feelImg = '1'; return; }
    if (img.complete && img.naturalWidth > 0) { img.dataset.feelImg = '1'; return; } // ya cargo: no re-pedir

    const caja = Math.round(img.getBoundingClientRect().width) || img.clientWidth || 0;
    const base = caja > 0 ? caja : Math.min(window.innerWidth || 800, 800);
    const ancho = elegir(Math.round(base * dpr));

    u.searchParams.set('width', String(ancho));
    img.dataset.feelImg = '1';
    if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    img.setAttribute('src', u.toString());
  };

  const barrer = () => {
    document.querySelectorAll('img[loading="lazy"]:not([data-feel-img])').forEach(optimizar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', barrer, { once: true });
  } else {
    barrer();
  }
  // las apps inyectan imagenes despues; barremos unas pocas veces mas y paramos
  let intentos = 0;
  const id = window.setInterval(() => {
    barrer();
    if (++intentos >= 6) window.clearInterval(id);
  }, 900);
})();

/* ---------- 2. CONTROLADOR DEL BUNDLE BUILDER ---------- */
(() => {
  if (!window.location.pathname.startsWith('/apps/gbb/easybundle/9')) return;

  /* ---------- CONFIG ---------- */
  // Cierre real de la mecanica del mes (ultimo dia del mes en curso, 23:59:59 hora local).
  // Para fijar una fecha manual: new Date('2026-09-30T23:59:59-06:00').getTime()
  const monthlyDeadline = () => {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth() + 1, 0, 23, 59, 59, 999).getTime();
  };
  const PRICES = { '5': '$650', '10': '$999' };
  const choiceKey = 'feelink_pack_choice_v3';

  /* ---------- ESTADO ---------- */
  let choice = sessionStorage.getItem(choiceKey) === '5' ? '5' : '10';
  let queued = false;
  let writing = false;          // evita que nuestras propias escrituras redisparen el observer
  let observer = null;
  let root = null;              // contenedor del builder (no document.body)
  let nextButton = null;
  let progressEl = null;

  const setChoice = (next) => {
    choice = next === '5' ? '5' : '10';
    sessionStorage.setItem(choiceKey, choice);
  };

  /* ---------- COUNTDOWN (escribe en <html>, fuera del subarbol observado) ---------- */
  const deadline = monthlyDeadline();
  const tickCountdown = () => {
    const ms = Math.max(0, deadline - Date.now());
    const t = Math.floor(ms / 1000);
    const d = Math.floor(t / 86400);
    const h = String(Math.floor((t % 86400) / 3600)).padStart(2, '0');
    const m = String(Math.floor((t % 3600) / 60)).padStart(2, '0');
    const s = String(t % 60).padStart(2, '0');
    const label = d > 0 ? `${d}d ${h}:${m}:${s}` : `${h}:${m}:${s}`;
    document.documentElement.style.setProperty('--feel-countdown', JSON.stringify(label));
  };

  /* ---------- LECTURA (sin tocar el DOM) ---------- */
  const readSelectedCount = () =>
    Array.from(document.querySelectorAll('.gbbFooterProductQuantity')).reduce((total, el) => {
      const match = el.textContent.match(/\d+/);
      return total + (match ? Number(match[0]) : 1);
    }, 0);

  const ensureProgress = () => {
    if (progressEl && progressEl.isConnected) return progressEl;
    nextButton = document.querySelector('.gbbFooterNextButton');
    if (!nextButton || !nextButton.parentElement) return null;
    progressEl = document.querySelector('.feel-pack-progress');
    if (!progressEl) {
      progressEl = document.createElement('div');
      progressEl.className = 'feel-pack-progress';
      progressEl.setAttribute('role', 'button');
      progressEl.innerHTML =
        '<div class="feel-pack-progress__bar"></div><span class="feel-pack-progress__text"></span>';
      nextButton.parentElement.insertBefore(progressEl, nextButton);
    }
    return progressEl;
  };

  /* ---------- ESCRITURA (un solo bloque, con el observer en pausa) ---------- */
  const render = () => {
    queued = false;

    const count = readSelectedCount();
    const target = Number(choice);
    const done = count >= target;
    const pct = Math.min(100, Math.round((count / target) * 100));
    const reviewOpen = document.body.classList.contains('feel-review-open');

    writing = true;
    if (observer) observer.disconnect();
    try {
      const bar = ensureProgress();
      const body = document.body;

      body.dataset.feelChoice = choice;
      body.classList.toggle('feel-has-items', count > 0);
      body.classList.toggle('feel-pack-incomplete', !done);
      body.classList.toggle('feel-pack-complete', done);
      body.style.setProperty('--feel-progress', pct + '%');

      let cta = 'ELIGE TU PRIMER DISENO';
      if (count > 0 && !done) cta = 'CONTINUAR · ' + count + '/' + target;
      if (done) cta = 'FINALIZAR COMPRA · ' + PRICES[choice];
      body.style.setProperty('--feel-cta', JSON.stringify(cta));

      document
        .querySelectorAll('.gbbProductAddButton, .gbbProductQuantityAddButton')
        .forEach((control) => {
          control.style.pointerEvents = done ? 'none' : '';
          control.style.opacity = done ? '0.42' : '';
          control.setAttribute('aria-disabled', done ? 'true' : 'false');
        });

      if (bar) {
        bar.setAttribute('aria-valuemin', '0');
        bar.setAttribute('aria-valuemax', String(target));
        bar.setAttribute('aria-valuenow', String(Math.min(count, target)));
        bar.setAttribute('tabindex', count > 0 ? '0' : '-1');
        bar.setAttribute('aria-expanded', reviewOpen ? 'true' : 'false');
        const text = bar.querySelector('.feel-pack-progress__text');
        if (text) {
          text.textContent = done
            ? (choice === '10'
                ? 'DESBLOQUEASTE TU MYSTERY BOX · REVISAR'
                : target + ' de ' + target + ' elegidos · REVISAR')
            : Math.min(count, target) + ' de ' + target + ' elegidos';
        }
      }
    } finally {
      if (observer && root) observer.observe(root, { childList: true, subtree: true });
      writing = false;
    }
  };

  const queue = () => {
    if (writing || queued) return;
    queued = true;
    window.requestAnimationFrame(render);
  };

  const flash = (msg, delay) => {
    const text = document.querySelector('.feel-pack-progress__text');
    if (text) text.textContent = msg;
    window.setTimeout(queue, delay || 1600);
  };

  /* ---------- INTERACCION ---------- */
  document.addEventListener('click', (event) => {
    const bar = event.target.closest('.feel-pack-progress');
    if (bar && readSelectedCount() > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.body.classList.toggle('feel-review-open');
      bar.setAttribute(
        'aria-expanded',
        document.body.classList.contains('feel-review-open') ? 'true' : 'false'
      );
      return;
    }

    const addControl = event.target.closest('.gbbProductAddButton, .gbbProductQuantityAddButton');
    if (addControl && readSelectedCount() >= Number(choice)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      flash('PACK COMPLETO · MAXIMO ' + choice + ' TATUAJES · REVISAR');
      return;
    }

    const tier = event.target.closest('.gbbBoxSelectionItem');
    if (tier) {
      const next = tier.getAttribute('data-box-quantity') === '5' ? '5' : '10';
      const selected = readSelectedCount();
      if (next === '5' && selected > 5) {
        event.preventDefault();
        event.stopImmediatePropagation();
        flash('QUITA ' + (selected - 5) + ' PARA CAMBIAR AL PACK DE 5', 1800);
        return;
      }
      setChoice(next);
      document.body.classList.remove('feel-review-open');
      queue();
      return;
    }

    const next = event.target.closest('.gbbFooterNextButton');
    if (!next) return;
    if (readSelectedCount() < Number(choice)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const grid = document.querySelector('.gbbProductItem, .gbbProductsItemsContainer');
      if (grid) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        grid.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }, true);

  /* ---------- ARRANQUE ---------- */
  const boot = () => {
    root =
      document.querySelector('.gbbBodyWrapper') ||
      document.querySelector('.gbbMixPageWrapper') ||
      document.querySelector('[class*="gbbMix"]') ||
      document.querySelector('#MainContent') ||
      document.body;

    observer = new MutationObserver(() => queue());
    observer.observe(root, { childList: true, subtree: true });

    setChoice(choice);
    tickCountdown();
    window.setInterval(tickCountdown, 1000);
    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
